import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { ToastrService } from "ngx-toastr";
import { Role } from "../../../models/role";
import { RoleRegistrationRelations } from "../../../models/role_registration_relations";
import { RoleRegistrationsControllerService } from "../../../services/crossed-tables/role-registrations-controller.service";
import { RoleControllerService } from "../../../services/role-controller/role-controller.service";
import { BaseError } from "../base-error";

@Component({
  selector: "app-role-registrations",
  templateUrl: "./role-registrations.component.html",
  providers: [RoleRegistrationsControllerService, RoleControllerService],
})
export class RoleRegistrationsComponent extends BaseError implements OnInit {
  public roleRegistrationRelations: RoleRegistrationRelations[][] = [];
  public roles: Role[];
  public serviceId: string;
  public selectedRoleRegistrationRelations: RoleRegistrationRelations;
  public tableSwitched: boolean = false;

  constructor(private roleRegistrationsControllerService: RoleRegistrationsControllerService,
              private roleController: RoleControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.getRolesList();
  }

  public getRolesList() {
    this.roleController.getRolesList(this.serviceId, false).subscribe(
      (data) => {
        this.roles = data;
        this.getRoleRegistrationRelations();
      },
    );
  }

  public getRoleRegistrationRelations() {
    if (this.serviceId) {
      this.roleRegistrationsControllerService.getroleRegistrationsRelationsList(this.serviceId).subscribe(
        (data) => {
          this.roleRegistrationRelations = data;
          this.fillShortName();
          if (this.tableSwitched) {
            this.tableSwitched = false;
            this.switchHeadings();
          }
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
      );
    }
  }

  public fillShortName() {
    if (this.roleRegistrationRelations[0]) {
      this.roleRegistrationRelations[0].forEach((item) => {
        const roleItem = this.roles.find((role) => role.id === item.roleId);
        item.roleShortName = roleItem === null ? item.roleName.substring(0, 20) : (roleItem.shortName === null ? item.roleName.substring(0, 20) : roleItem.shortName);
      });
    }
  }

  public updateRoleRegistration(roleRegistrationRelation: RoleRegistrationRelations) {
    this.roleRegistrationsControllerService.saveRoleRegistrations(this.serviceId, roleRegistrationRelation).subscribe(
      (data) => {
        this.getRoleRegistrationRelations();
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public editRoleRegistration(roleRegistrationRelations: RoleRegistrationRelations) {
    if (roleRegistrationRelations) {
      this.selectedRoleRegistrationRelations = roleRegistrationRelations;
      if (roleRegistrationRelations.roleHasRegistration) {
        this.selectedRoleRegistrationRelations.roleHasRegistration = false;
        this.updateRoleRegistration(this.selectedRoleRegistrationRelations);
      } else {
        roleRegistrationRelations.roleHasRegistration = true;
        this.updateRoleRegistration(roleRegistrationRelations);
      }
    }
  }

  public switchHeadings() {
    this.tableSwitched = !this.tableSwitched;
    const switchedEntries = [];
    if (this.roleRegistrationRelations[0]) {
      for (let j = 0; j < this.roleRegistrationRelations[0].length; j++) {
        const newRow = [];
        for (let i = 0; i < this.roleRegistrationRelations.length; i++) {
          newRow.push(this.roleRegistrationRelations[i][j]);
        }
        switchedEntries.push(newRow);
      }
      this.roleRegistrationRelations = switchedEntries;
    }
  }
}
